;(function (jQuery) {
    "use strict";

    function StripeUpdatePaymentMethod() {
        var fn = {
            init: function () {
                if (jQuery('#stripe-cc-update-payment-details-form').length > 0) {
                    fn.setupStripeUpdate();
                }
            },

            setupStripeUpdate: function () {
                const stripe = Stripe(window.stripe_publishable_key);
                const client_secret = window.client_secret;
                const elements = stripe.elements();
                const card = elements.create('card');
                card.mount('#stripe-cc-card-element');

                jQuery('#js-update-stripe-cc-button').on('click', async function () {
                    try {
                        const { setupIntent, error } = await stripe.confirmCardSetup(client_secret, {
                            payment_method: {
                                card: card,
                            },
                        });

                        if (error) {
                            fn.showError(error.message);
                        } else {
                            fn.processCardUpdate(setupIntent.payment_method);
                        }
                    } catch (err) {
                        console.error('Unexpected error:', err);
                    }
                });
            },
            processCardUpdate: function (payment_method_id) {
                const postData = {
                    action: 'update_stripe_payment_method',
                    payment_method_id: payment_method_id,
                    contribution_id: window.contribution_id,
                    membership_id: window.membership_id,
                    security: window.process_payment_nonce,
                };

                jQuery.ajax({
                    url: window.ajax_url,
                    method: 'POST',
                    data: postData,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            jQuery('#stripe-cc-update-payment-details-form').hide();
                            jQuery('.js-payment-method-update-error').hide();
                            jQuery('.js-payment-method-update-success').show();
                        } else {
                            fn.showError(response.data.message);
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('AJAX error:', status, error);
                        alert('An error occurred while updating your payment method. Please try again.');
                    },
                });
            },

            showError: function (message) {
                jQuery('.js-payment-method-update-success').hide();
                jQuery('.js-payment-method-update-error').show();
                jQuery('.js-payment-method-update-error .js-bm-alert-message').text(message);
            },
        };

        jQuery(document).ready(fn.init);
    }

    new StripeUpdatePaymentMethod();

    function CancelStripePaymentMethod() {
        var fn = {
            init: function () {
                if (jQuery('#js-cancel-stripe-cc-button').length > 0) {
                    jQuery('#js-cancel-stripe-cc-button').click(fn.cancelStripe);
                }
            },

            cancelStripe: function () {
                const postData = {
                    action: 'cancel_stripe_payment_method',
                    contribution_id: window.contribution_id,
                    membership_id: window.membership_id,
                    security: window.cancel_payment_nonce,
                };
                jQuery.ajax({
                    url: window.ajax_url,
                    method: 'POST',
                    data: postData,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            jQuery('#stripe-cc-update-payment-details-form').hide();
                            jQuery('.js-payment-method-cancel-error').hide();
                            jQuery('.js-payment-method-cancel-success').show();
                            jQuery('#js-cancel-stripe-cc-button').remove();
                        } else {
                            fn.showError(response.data.message);
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('AJAX error:', status, error);
                        alert('An error occurred while updating your payment method. Please try again.');
                    },
                });
            },

            showError: function (message) {
                jQuery('.js-payment-method-cancel-success').hide();
                jQuery('.js-payment-method-cancel-error').show();
                jQuery('.js-payment-method-cancel-error .js-bm-alert-message').text(message);
            },
        };

        jQuery(document).ready(fn.init);
    }

    new CancelStripePaymentMethod();

    function StripeCheckoutUpdatePaymentMethod() {
        var fn = {
            init: function() {
                if (jQuery('#js-update-stripe-cc-checkout-button').length > 0) {
                    jQuery('#js-update-stripe-cc-checkout-button').click(fn.updateStripeCheckoutPayment);
                }
            },

           updateStripeCheckoutPayment: function () {
                const postData = {
                    action: 'update_stripe_checkout_payment_method',
                    contribution_id: window.contribution_id,
                    membership_id: window.membership_id,
                    referrer: window.location.href,
                    security: window.process_payment_nonce,
                };
                jQuery.ajax({
                    url: window.ajax_url,
                    method: 'POST',
                    data: postData,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            window.location.href = response.url;
                        } else {
                            fn.showError(response.data.message);
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('AJAX error:', status, error);
                    },
                });
            },

            showError: function (message) {
                jQuery('.js-payment-method-update-success').hide();
                jQuery('.js-payment-method-update-error').show();
                jQuery('.js-payment-method-update-error .js-bm-alert-message').text(message);
            },
        };
        
        jQuery(document).ready(fn.init);
    }

    new StripeCheckoutUpdatePaymentMethod();
})(jQuery);